<template>
  <div>
    <button
      v-tooltip="!props.customer.is_active ? t('common.message.customer_archived_tooltip') : null"
      @click="editCustomer"
      class="tw-inline-flex tw-items-center tw-justify-center tw-border-none tw-bg-transparent tw-ease-in-out tw-text-primary-400 tw-underline hover:tw-text-primary-600 tw-transition-colors tw-duration-300"
      :disabled="!props.customer.is_active"
      :class="
        props.customer.is_active ? 'tw-cursor-pointer' : 'tw-cursor-not-allowed tw-opacity-50'
      "
    >
      {{ t('common.forms.edit') }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import router from '@/router';

const { t } = useI18n();

const props = defineProps<{
  customer: any;
}>();

const editCustomer = () => {
  router.push({
    name: 'edit-customer',
    params: { id: props.customer.id.toString() },
  });
};
</script>
